const splitSignalWords = (signalWords: string): string[] => signalWords.split(', ');

export default splitSignalWords;
